export function mediaDownloadUrl(downloadingDisabled, media) {
  return (!downloadingDisabled && media.download_url && media.download_url !== '') ?
    media.download_url : null
}

export default function shouldShowDownloadDropdown(downloadingDisabled, media, attachments) {
  return (mediaDownloadUrl(downloadingDisabled, media) || attachments.length > 0)
}
